/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Sage_Eagle_RoamInputs */

const en_pale_sage_eagle_roam = /** @type {(inputs: Pale_Sage_Eagle_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group name`)
};

const de_pale_sage_eagle_roam = /** @type {(inputs: Pale_Sage_Eagle_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppenname`)
};

/**
* | output |
* | --- |
* | "Group name" |
*
* @param {Pale_Sage_Eagle_RoamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_sage_eagle_roam = /** @type {((inputs?: Pale_Sage_Eagle_RoamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Sage_Eagle_RoamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_sage_eagle_roam(inputs)
	return de_pale_sage_eagle_roam(inputs)
});